module.exports = __webpack_public_path__ + "static/media/DocumentSync.b314a982.jpg";